const translations = {
    logout: 'Log Out'
};

export default translations;
